export default "__VITE_ASSET__CdYPIWEb__"